import axios from '@/utils/api.request'
let previousUrl = '/api'

// 获取基础案件数据
export const getStat = (type) => {
  return axios.request({
    url: `${previousUrl}/stat/${type}`,
    method: 'get'
  })
}

// 条件检索数据
export const postStat = (data) => {
  return axios.request({
    url: `${previousUrl}/stat`,
    data: data,
    method: 'post'
  })
}
